import { type ReactElement } from 'react'
import { type AccountId, getAccountResidentName, isNotEmpty } from '@terros/common'
import { useAccount, useTranslation } from '@front/model'
import { TAlert } from '@components'

export function ServerFlagWarning({ accountId, stageName }: { accountId: AccountId; stageName: string }): ReactElement {
  const { t } = useTranslation()
  const { data } = useAccount(accountId)
  const name = getAccountResidentName(data?.resident)
  return (
    <TAlert variant='warning'>
      {t('{{account}} is in {{stage}}, a stage that flags recordings. Choose another location.', {
        account: isNotEmpty(name) ? name : accountId,
        stage: stageName,
      })}
    </TAlert>
  )
}
